import React from "react";
import { Form, Input, Button } from "antd";
import { get } from 'lodash';

const TextInputUrl = ({
  values,
  errors,
  handleSubmit,
  setFieldValue,
  setFieldTouched,
  name,
  label,
  formItemLayout,
  placeholder,
  readOnly
}) => (
    <Form.Item label={label} {...formItemLayout}
      hasFeedback={!!get(errors, name)}
      validateStatus={get(errors, name) && "error"}
      help={get(errors, name)}
    >
      <Input.Search
        placeholder={placeholder}
        value={get(values, name)}
        onChange={event => setFieldValue(name, event.target.value)}
        onBlur={() => setFieldTouched(name)}
        //onPressEnter={handleSubmit}
        readOnly={readOnly}
        enterButton
        onSearch={value => value.startsWith('http') ? window.open(value) : window.open('http://' + value)}
      />

    </Form.Item>
  );

export default TextInputUrl;
